import React, { useEffect } from "react";
import logo from "../images/new_logo.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { DataLatest } from "./LatestData";

function Latest() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <section className="section blog" data-aos="fade-up">
        <div className="section-title">
          <h2>Latest Projects</h2>
          <div className="underline"></div>
        </div>

        <div className="section-center blog-center" data-aos="fade-in">
          {DataLatest.map((latest) => {
            const { name, img, description, read, link } = latest;
            return (
              <div className="card">
                <div className="card-side card-front">
                  <img className="f" src={img} alt="" />
                  <div className="card-info">
                    <h4 style={{ textAlign: "center" }}>{name}</h4>
                    <p style={{ textAlign: "center" }}>{description}</p>
                    <div className="card-footer">
                      <img src={logo} alt="" />
                      <p>{read} read</p>
                    </div>
                  </div>
                </div>
                <div className="card-side card-back">
                  <a href={link} className="btn">
                    Live
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}

export default Latest;
